import { render, staticRenderFns } from "./role-menu.vue?vue&type=template&id=447604c8&scoped=true&"
import script from "./role-menu.vue?vue&type=script&lang=js&"
export * from "./role-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447604c8",
  null
  
)

export default component.exports